import React from "react";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

function Experience() {
  const experiences = [
    {
      company: "BC Hydro",
      title: "DevOps Engineer",
      period: "May 2025 - Present",
      location: "Vancouver, BC",
      achievements: [
        "Redesigned PostgreSQL-backed geospatial lookups with Redis GEO indexes, hashes, and distributed locks, reducing Wildfire Risk Rating API latency by ~40%.",
        "Automated SAP Enable Now backups with Kubernetes CronJobs across 21 workspaces (~43 GB), using staggered schedules to avoid API overload and export conflicts.",
        "Built a centralized log-and-alert pipeline with Fluent Bit, VictoriaLogs, GitHub Actions, and Python for backup health, failure alerts, and expiry monitoring.",
        "Consolidated repository security scanning into reusable GitHub Actions workflows with Dependabot, CodeQL, Trivy, secret scanning, and SARIF code-scanning output.",
        "Built a Kubernetes health-reporting service in TypeScript/Node.js with namespace-scoped ServiceAccount JWT auth and startup SelfSubjectReview validation."
      ],
      skills: ["Kubernetes", "Redis", "TypeScript", "Python", "GitHub Actions", "DevSecOps", "Observability"]
    },
    {
      company: "SWAROVSKI",
      title: "Sales Associate (Seasonal)",
      period: "Nov 2023 - Dec 2023",
      location: "Vancouver, Canada",
      achievements: [
        "Enhanced shopping experiences and increased sales performance.",
        "Managed product inquiries and returns with exceptional service.",
        "Collaborated to optimize retail operations and inventory management."
      ],
      skills: ["Customer Service", "Sales", "Product Knowledge", "Problem Solving", "Retail Operations"]
    },
    {
      company: "DDC Academy",
      title: "Teaching Assistant (Intern)",
      period: "Aug 2021 - Sep 2021",
      location: "Beijing, China",
      achievements: [
        "Provided grading and feedback, improving academic outcomes.",
        "Created and edited video content for online course archives.",
        "Supported faculty in curriculum development and student engagement."
      ],
      skills: ["Grading", "Feedback", "Video Editing", "Academic Support", "Time Management"]
    }
  ];

  return (
    <div className="education-container">
      <div className="education-timeline">
        {experiences.map((exp, index) => (
          <div key={index} className="education-card">
            <div className="education-header">
              <h3>{exp.company}</h3>
            </div>
            <p className="degree">{exp.title}</p>
            <div className="education-meta">
              <span><FaCalendarAlt /> {exp.period}</span>
              <span><FaMapMarkerAlt /> {exp.location}</span>
            </div>
            <div className="experience-description">
              <ul>
                {exp.achievements.map((achievement, idx) => (
                  <li key={idx}>{achievement}</li>
                ))}
              </ul>
            </div>
            <div className="course-tags">
              {exp.skills.map((skill, idx) => (
                <span key={idx} className="course-tag">{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Experience;
